import React from 'react';
import { Divider } from '../../Divider';
import styles from './Select.Divider.scss';
export var SelectDivider = function SelectDivider() {
  return React.createElement("div", {
    "aria-hidden": true,
    className: styles.divider
  }, React.createElement(Divider.Horizontal, null));
};
SelectDivider.displayName = 'Select.Divider';